import classNames from 'classnames';

export function PercentageBar({
  value,
  className = '',
  classNameBar = '',
  markerValue,
}: {
  value: string;
  className?: string;
  classNameBar?: string;
  /** When set (0–100), renders a vertical marker tick at this position, e.g. a budget target. */
  markerValue?: string;
}) {
  const classNameCombined = classNames(
    'relative flex items-center bg-background rounded-md overflow-hidden',
    className,
  );
  return (
    <div className={classNameCombined}>
      <div className={`flex bg-[#3F98B4] rounded-md h-[100%] ${classNameBar}`} style={{ width: `${value}%` }}></div>
      {markerValue !== undefined && (
        <div
          className="absolute top-0 bottom-0 w-0.5 bg-white"
          style={{ left: `${markerValue}%` }}
          aria-hidden
        ></div>
      )}
    </div>
  );
}
